export const rtlTextFieldProps = {
  InputProps: {
    sx: { textAlign: 'right', direction: 'rtl' }
    },
    InputLabelProps: {
      sx: {
        right: 20,
        left: 'auto',
        transformOrigin: 'right top',
        position: 'absolute'
      }
    },
    sx: {
      '& .MuiFormHelperText-root': {
        textAlign: 'right'
      },
      '& .MuiOutlinedInput-notchedOutline': {
      textAlign: 'right'
    }
  }
};
